/*
 * Product · FAQ accordion (sections/pdp-faq.liquid). Mirrors Replo's
 * collapsibles: answers open and close instantly, and opening one closes the
 * other open answer in the same column ([data-pdp-faq-group]).
 */
(function () {
  if (window.pdpFaqLoaded) return;
  window.pdpFaqLoaded = true;

  var GROUP = '[data-pdp-faq-group]';
  var ITEM = '[data-pdp-faq-item]';
  var TOGGLE = '[data-pdp-faq-toggle]';

  function setOpen(item, open) {
    var button = item.querySelector(TOGGLE);
    var panel = button && document.getElementById(button.getAttribute('aria-controls'));
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('is-open', open);
    panel.hidden = !open;
  }

  function openItem(item) {
    var group = item.closest(GROUP);
    if (group) {
      group.querySelectorAll(ITEM).forEach(function (other) {
        if (other !== item) setOpen(other, false);
      });
    }
    setOpen(item, true);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(TOGGLE);
    if (!button) return;
    var item = button.closest(ITEM);
    if (!item) return;
    if (button.getAttribute('aria-expanded') === 'true') {
      setOpen(item, false);
    } else {
      openItem(item);
    }
  });

  // Theme editor: selecting a card's block opens it.
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest(ITEM);
    if (item && item.querySelector(TOGGLE)) openItem(item);
  });
})();
